
import Provider from "./provider";

export default Provider.extend({});
